<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12  col-md-11 col-lg-6">
        <Toast />
        <div
          class="col-md-12   d-flex align-items-center justify-content-center"
          style="height: 100vh"
        >
          <div class="col-12 mx-0 px-0 col-md-12 col-lg-11" style="height: 50%">
            <!-- <div > -->
            <div class="text-center col-md-12 heading-text">
              Enter Verification code
            </div>
            <div
              class="
                font-weight-bold
                col-md-12
                text-secondary
              "
            >
              <div class="col-12 col-md-12 d-flex mb-3 justify-content-center ">
                <div  class="col-9 col-sm-9 col-lg-9  text-center ">
                  <span class="text-center">
                    Enter the 6-digit verification code sent to
                  </span>
                  <span class="text-primary">
                    {{ partialEmail ? partialEmail : ""  }} and {{ partialNumber ? partialNumber : "" }}
                  </span>
                </div>
              </div>
            </div>
            <div
              class="col-md-12 d-flex justify-content-center align-items-center"
            >
              <!-- <div class="container  ">  -->
              <div class="col-12 px-0 mx-0 col-md-12 col-lg-10">
                <div class="row  text-center ">
                    <div
                    class=" col-md-12 px-0 mx-0 d-flex justify-content-center  otp-field"
                  >
                    <input
                      ref="firstFocus"
                      v-model="firstInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputOne"
                    />
                    <input
                      ref="secondFocus"
                      v-model="secondInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputTwo"
                    />
                    <input
                      ref="thirdFocus"
                      v-model="thirdInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputThree"
                    />
                    <input
                      ref="fourthFocus"
                      v-model="fourthInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputFour"
                    />
                    <input
                      ref="fifthFocus"
                      v-model="fifthInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputFive"
                    />
                    <input
                      ref="sixFocus"
                      v-model="sixthInput"
                      class="m-1 form-control rounded inputtwo bg-secondary"
                      type="text"
                      maxlength="1"
                      @input="handleOTPInputSix"
                    />
                  </div>
                  <div class="mt-4 col-md-12 d-flex justify-content-center">
                    <button
                      class="primary-bg px-4 default-btn text-white border-0"
                      @click="verifyOTP"
                    >
                      <i
                        class="fas fa-circle-notch fa-spin codeModal"
                        v-if="loading"
                      ></i
                      >Verify
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="
                    col-md-12
                      content
                      d-flex
                      flex-wrap
                      justify-content-center
                      
                    "
                  >
                    <span>Didn't get the code</span>
                    <a href="#" class="text-decoration-none ms-3"
                      >Resend(1/3)</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->

            <!-- <div class="col-md-12 d-flex justify-content-center">
                            <button class="default-btn border-0 primary-bg text-white">Verify</button>
                        </div> -->
          </div>
        </div>
      </div>
      <div class="col-md-6 bckimage" id="onboarding-visuals">
        <img src="../../assets/enter-otp-animate.svg" alt="" />
      </div>
    </div>
  </div>
  <ConfirmDialog />
</template>

<script>
import { ref } from "vue";
// import { useRouter } from "vue-router";
import router from "../../router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    // const router = useRouter();
    const loading = ref(false);
    const firstFocus = ref("")
    const secondFocus = ref("")
    const thirdFocus = ref("")
    const fourthFocus = ref("")
    const fifthFocus = ref("")
    const sixFocus = ref("")
    const myonboardingData = ref(store.getters.onboardingObject);

    const firstInput = ref();
    const secondInput = ref();
    const thirdInput = ref();
    const fourthInput = ref();
    const fifthInput = ref();
    const sixthInput = ref();
    const toast = useToast();
    const confirm = useConfirm();
    const partialEmail = ref(myonboardingData.value.email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, "$1***@$2"));
    // .replace(/(\w{3})[\w.-]+@([\w.]+\w)/, "$1***@$2")
    const partialNumber = ref(myonboardingData.value.phoneNumber.slice(0, 6) + myonboardingData.value.phoneNumber.slice(2).replace(/.(?=...)/g, '*'));
    // .slice(0, 2) + string.slice(2).replace(/.(?=...)/g, '*')

    const getAllOnboadingData = () => {
      const onboardingRes = localStorage.getItem("onboardingData");
      console.log(onboardingRes, " onboardingData556");
      console.log(myonboardingData.value, "jhkljhkjhkl");
    };
    getAllOnboadingData();

    const handleOTPInputOne = () =>{
         secondFocus.value.focus()
          if(!firstInput.value ){
            firstFocus.value.focus()
        }

    }
    const handleOTPInputTwo = () =>{
         thirdFocus.value.focus()
          if(!secondInput.value ){
            firstFocus.value.focus()
        }
    }
    const handleOTPInputThree = () =>{
        fourthFocus.value.focus()
         if(!thirdInput.value ){
            secondFocus.value.focus()
        }
    }
    const handleOTPInputFour = () =>{
        fifthFocus.value.focus()
         if(!fourthInput.value ){
            thirdFocus.value.focus()
        }
    }
    const handleOTPInputFive = () =>{
        sixFocus.value.focus()
         if(!fifthInput.value ){
            fourthFocus.value.focus()
        }
        // if(sixthInput.value.key === "Backspace" ){
        //      fifthFocus.value.focus()
        // }
    }
    const handleOTPInputSix = () =>{
        if(!sixthInput.value ){
            fifthFocus.value.focus()
        }
    }
    // if(e.target.value > 0 && firstInput.value <  - 1){
        //    return e.target.value.nextElementSlibling.focus();
        // }

        // if(e.key === "Backspace" && firstInput.value > 0){
        //     e.target.value.previousElementSlibling.focus()
        // }

        // if(firstInput.value ===  - 1){
        //     submit()
        // }

    const verifyOTP = async () => {
      loading.value = true;
      let allInputValue = `${firstInput.value}${secondInput.value}${thirdInput.value}${fourthInput.value}${fifthInput.value}${sixthInput.value}`;
      // console.log(allInputValue)

      // // console.log(onboardingRes," onboardingData556");
      let obj = {
        id: myonboardingData.value.id,
        churchName: myonboardingData.value.churchName,
        email: myonboardingData.value.email,
        phoneNumber: myonboardingData.value.phoneNumber,
        // bankAccount: myonboardingData.value,
        password: myonboardingData.value.password,
        countryID: myonboardingData.value.countryID,
        subscriptionPlanID: myonboardingData.value.subscriptionPlanID,
        bankCode: "035",
        bankName: "Wema bank",
        activationCode: allInputValue,
        password: "123456",
        // amount: this.memberPerMonth,
        referrer: "WEMA",
      };
      console.log(obj, "🙌🙌😥😒🤷‍♂️🤷‍♂️🤦‍♂️");

      try {
        loading.value = true;
        const response = await axios.post("/OTPConfirmation", obj);
        console.log(response, "response");
        if (!response.data.token) {
          const preToken = localStorage.getItem("pretoken");
          localStorage.setItem("token", preToken);
          localStorage.removeItem("pretoken");
        } else {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("roles", JSON.stringify(["Admin"]));
        }
        toast.add({
          severity: "success",
          summary: "Verification successful",
          detail: `Congrats, your account has successful`,
          life: 3000,
        });
        router.push("/next");
      } catch (error) {
        console.log(error);
      }

      // loading.value = true;

      firstInput.value = "";
      secondInput.value = "";
      thirdInput.value = "";
      fourthInput.value = "";
      fifthInput.value = "";
      sixthInput.value = "";
      loading.value = false;
    };

    return {
      handleOTPInputTwo,
      handleOTPInputFour,
      handleOTPInputFive,
      handleOTPInputThree,
      handleOTPInputSix,
      verifyOTP,
      firstFocus,
      secondFocus,
      thirdFocus,
      fourthFocus,
      fifthFocus,
      sixFocus,
      handleOTPInputOne,
      partialEmail,
      partialNumber,
      myonboardingData,
      firstInput,
      secondInput,
      thirdInput,
      fourthInput,
      fifthInput,
      sixthInput,
      loading,
    };
  },
};
</script>
<style scoped>
.otp-field input {
  width: 50px;
  font-size: 32px;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  margin: 2px;
  border: 2px solid #55525c;
  background: #21232d;
  font-weight: bold;
  color: #fff;
  outline: none;
  transition: all 0.1s;
}

.otp-field input:focus {
  border: 1px solid #900a39;
  box-shadow: 0 0 2px 2px #900a39;
}

.disabled {
  opacity: 0.5;
}
.space {
  margin-left: 1rem !important;
}

.inputtwo {
  color: #200419 !important;
  font: normal normal 800 1.5rem Nunito sans;
  font-size: 35px;
}
.digit-box {
  height: 4rem;
  width: 2rem;
  border: 2px solid black;
  display: inline-block;
  border-radius: 5px;
  margin: 5px;
  padding: 15px;
  font-size: 3rem;
}

.digit-box:focus {
  outline: 3px solid black;
}

.digit-group input {
  width: 30px;
  height: 50px;
  background-color: rgb(203, 203, 203);
  border: none;
  border-radius: 9px;
  line-height: 50px;
  text-align: center;
  font-size: 24px;
  font-family: "Raleway", sans-serif;
  font-weight: 200;
  color: white;
  margin: 0 2px;
}

.prompt {
  margin-bottom: 20px;
  font-size: 20px;
  color: white;
}

.heading-text {
  font: normal normal 800 1.5rem Nunito sans;
  font-size: 35px;
}
.bckimage img {
  /* background-image: url(../../assets/enter-otp-animate.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover; */
  height: 100vh;
  width: 100%;
}
#onboarding-visuals {
  width: 100%;
  /* background: #4aa858; */
  height: 100;
  background-image: -webkit-linear-gradient(top, #afafaf 0%, #fdfffe 100%);
  transition: all 0.7s ease-in-out;
}

@media screen and (max-width: 800px) {
  #onboarding-visuals {
    display: none !important;
  }
}

@media screen and (max-width: 388px) {
    .otp-field{
        display: flex;
        flex-wrap: wrap;
        width: 100% !important;
        
    }
}
@media screen and (max-width: 308px) {
    .otp-field{
        display: flex;
        flex-wrap: wrap;
        width: 100% !important;
        
    }
}
</style>